import React, {useMemo} from 'react';

const colors = ['#69D994', '#9DDEAD', '#B3E5C2', '#E5F6EB'];
const dotCount = 40;

const randRange = (min: number, max: number) => (
	Math.random() * (max - min) + min
);

const useRapidRebounds = () => (
	useMemo(() => {
		const generated: JSX.Element[] = [];
		for (let i = 0; i < dotCount; i++) {
			const size = randRange(1, 5);
			const colorIndex = i % 4;
			const color = colors[colorIndex];
			const speed = randRange(8, 12);
			const delay = randRange(0, 2);

			// Create directional motion with "bounce" effect
			const direction = randRange(0, 360);
			const radians = direction * Math.PI / 180;
			const distance = randRange(20, 70);
			const startX = randRange(0, 100);
			const startY = randRange(0, 100);
			const endX = Math.max(0, Math.min(100, startX + Math.cos(radians) * distance));
			const endY = Math.max(0, Math.min(100, startY + Math.sin(radians) * distance));

			generated.push(
				<circle
					key={i}
					cx={startX}
					cy={startY}
					r={size}
					fill={color}
					opacity='0.8'
				>
					<animate
						attributeName='cx'
						values={`${startX};${endX};${startX}`}
						dur={`${speed}s`}
						begin={`${delay}s`}
						repeatCount='indefinite'
						calcMode='linear'
					/>
					<animate
						attributeName='cy'
						values={`${startY};${endY};${startY}`}
						dur={`${speed}s`}
						begin={`${delay}s`}
						repeatCount='indefinite'
						calcMode='linear'
					/>
					<animate
						attributeName='r'
						values={`${size};${size*1.2};${size}`}
						dur={`${speed}s`}
						begin={`${delay}s`}
						repeatCount='indefinite'
					/>
				</circle>
			);
		}
		return generated;
	}, [])
);

export const RapidRebounds: React.FC = () => {
	const dots = useRapidRebounds();
	return (
		<div>
			<svg
				width='100%'
				height='100%'
				viewBox='0 0 100 100'
				preserveAspectRatio='none'
			>
				{dots}
			</svg>
		</div>
	);
};
